<template>
  <Text :title="$t('common.permission.desc')">
    <template #content>
      <div style="width: 100%;display: flex;justify-content: space-between">
        <div style="width:100%;font-size: 13px;font-weight:500;display: flex;justify-content: space-between">
          <div>
            {{ $t('expand.title') }}
            <br>
            {{ $t('expand.title.2') }}
          </div>
          <el-button link type="primary" @click="handleClickExpand">{{ $t('expand.detail') }}</el-button>
        </div>
      </div>
      <div v-if="isExpand" style="display: flex;margin-top: 10px;">
        <div class="txt" style="display: flex;flex-direction: column;align-items:flex-end">
          <div class="text_title">{{ $t("left.common.depname") }}</div>
          <br>
          <div class="text_title" style="margin-top: 3px;">{{ $t("left.common.depuser") }}</div>
          <div class="text_title">{{ $t("left.common.des") }}</div>
        </div>
        <div class="txt" style="display: flex;flex-direction: column;justify-content: space-around">
          <div style="margin-left: 5px;">
            {{ $t("left.common.depname.content") }}
            <br>
            {{ $t("left.common.depname.content1") }}
          </div>
          <div style="margin-left: 5px;">{{ $t("left.common.depuser.content") }}</div>
          <div style="margin-left: 5px;">{{ $t("left.common.des.content") }}</div>
          <div style="margin-left: 5px;">{{ $t("left.common.des.content1") }}</div>
        </div>
      </div>
    </template>
  </Text>
  <Text :title="$t('common.department.setting')">
    <template #settings>
      <el-button size="small" type="primary" v-if="isSuperAdmin" @click="dialogVisibleAddDepartment = true"
      >{{ $t('common.department.add') }}
      </el-button
      >
    </template>
    <template #content>
      <el-table
          :data="tableData"
          height="auto"
          style="width: 100%"
          :row-class-name="tableRowClassName"
          :cell-style="headerClassName"
          :header-cell-style="rowClassName"
          v-loading="isLoadingDepart"
          @cell-mouse-leave="clearVisiblePopover"
      >
        <el-table-column prop="name" :label="$t('common.department.name')"
                         :width="handleClickSelectWidth">
          <template #default="{row}">
            <div :ref="ref => (refMap[`${row.id}_name`] = ref)"
                 @mouseover.stop="handleRef(refMap[`${row.id}_name`], row, 1)"
                 v-if="getTextLength(row.name)>= sizeMaxNumber"
                 class="over_normal"
                 :key="row.name">
              {{
                getTextLength(row.name) > sizeMaxNumber ? formatText(row.name, sizeMaxNumber) : row.name
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('common.time.add')"
                         :width="flexWidth('createTime', tableData, $t('common.time.add'))">
          <template #default="{row}">
            {{ row.createTime.split(" ")[0] }}
          </template>
        </el-table-column>
        <el-table-column :width="flexWidth('count', tableData, $t('common.department.numberofpeople'))" prop="count"
                         :label="$t('common.department.numberofpeople')"/>
        <el-table-column
            prop="userStatus"
            :label="$t('common.cz')"
            width="140"
            min-width="140"
        >
          <template #default="{ row, column, $index }">
            <el-button
                type="primary"
                link
                v-if="isSuperAdmin"
                @click="updatesData(row, column, $index)"
            >{{ $t('common.update') }}
            </el-button
            >
            <span style="color: grey; margin: 0px 6px" v-if="isSuperAdmin">|</span>
            <ConfirmDeletePopover
                :visible="row.popoverVisible"
                :width="164"
                :message="$t('sys.message.ask.type.delete')"
                @update:visible="(value) => (row.popoverVisible = value)"
                @confirm:delete="handleDelete(row, column, $index)"
            >
              <template #settings>
                <el-button type="danger" link @click="row.popoverVisible = true" v-if="isSuperAdmin"
                >{{ $t('common.delete') }}
                </el-button
                >
              </template>
            </ConfirmDeletePopover>
          </template>
        </el-table-column>
      </el-table>
      <div class="pages">
        <el-pagination
            size="small"
            v-model:current-page="current"
            v-model:page-size="size"
            v-if="total"
            layout="total, prev, pager, next"
            :total="total"
            @current-change="handleCurrentChange"
        />
      </div>
    </template>
  </Text>
  <Dialog
      v-model="dialogVisible"
      :title="$t('common.department.update')"
      :dialogVisible="dialogVisible"
      :isHeadLine="false"
      :width="'400'"
      @update:dialogVisible="updateDialogVisible"
  >
    <template #content>
      <div class="my_forms">
        <div style="font-weight: 600">{{ $t('common.department.name') }}：</div>
        <div style="margin-top: 10px">
          <el-input size="small" v-model="cosNames"/>
        </div>
      </div>
      <div id="sendRequire">
        <el-button size="small" type="primary" @click="updatesDataDep(rows)">{{ $t('common.confirm') }}</el-button>
      </div>
    </template>
  </Dialog>
  <Dialog
      v-model="dialogVisibleAddDepartment"
      :title="$t('common.department.add')"
      :isHeadLine="false"
      :width="'400px'"
      :dialogVisible="dialogVisibleAddDepartment"
      @update:dialogVisible="updateDialogVisibleDepartment"
  >
    <template #content>
      <div class="my_forms">
        <div style="font-size: 13px;font-weight: normal">{{ $t('common.department.name') }}：</div>
        <div style="margin-top: 14px">
          <el-input size="small" v-model="departmentNameAdd"/>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="settings_btn">
        <el-button size="small" type="primary" @click="addDepartment">{{ $t('common.confirm') }}</el-button>
      </div>
    </template>
  </Dialog>

  <el-popover
      v-model:visible="visiblePopover"
      :virtual-ref="tempRef"
      virtual-triggering
      :width="'max-content'"
      trigger="hover"
      :popper-style="{ minWidth: '60px', width: 'auto' }"
      effect="dark"
      placement="bottom"
      :show-after="1200"
  >
    <template v-if="popoverType === 1">
      <div class="popover-content">{{ activeItemElpopover.name }}</div>
    </template>
  </el-popover>
</template>

<script setup>
import {ref, onMounted, computed, watch} from "vue";
import dayjs from "dayjs";
import {useStore} from "vuex";

import Text from "./Text.vue";
import Dialog from "@/components/Dialog.vue";
import ConfirmDeletePopover from "@/components/ConfirmDeletePopover.vue";
import {ElTable} from "element-plus";
import {flexWidth} from "@/utils/tableWidth";
import {auto} from "@popperjs/core";
import {formatText, getTextLength} from "@/utils/util";
import {debouncePlus} from "@/utils/mylodash";
import {POPOVER_DELAY_TIME} from "@/utils/statusParams";
import {i18n} from "@/lang";
// 数据加载
const isLoadingDepart = computed(() => store.state.groups.isLoadingDepart);
const store = useStore();

const isSuperAdmin = computed(() => store.getters["user/isSuperAdmin"])
const isAdmin = computed(() => store.getters["user/isAdmin"])
const lang = computed(() => store.state.system.langLocal)
// 对话框的展示 修改
const dialogVisible = ref(false);
const departmentName = ref("");
// 对话框展示 添加部门
const dialogVisibleAddDepartment = ref(false);
const departmentNameAdd = ref("");

const tableData = computed(() => store.state.groups.departList);
const teamId = computed(() => store.state.email.teamID);

// 是否展开内容
const isExpand = ref(false)
const handleClickExpand = () => {
  isExpand.value = !isExpand.value
}
// 更新对话框状态
const updateDialogVisible = (val) => {
  dialogVisible.value = val;
};
const updateDialogVisibleDepartment = (val) => {
  dialogVisibleAddDepartment.value = val;
};

const cosNames = ref("");
// 选择的行
const rows = ref();
// 分页
const current = computed(() => store.state.groups.pageDepart.current);
const size = computed(() => store.state.groups.pageDepart.size);
const total = computed(() => store.state.groups.pageDepart.total);

const handleCurrentChange = (page) => {
  store.commit("groups/setDepartPage", {current: page, size, total});
  store.dispatch("groups/getDepartList", {teamId: teamId.value});
};

// 修改部门
const updatesData = (row, column, $index) => {
  dialogVisible.value = true;
  cosNames.value = row.name;
  rows.value = {...row};
};

const updatesDataDep = async (row, column, $index) => {
  dialogVisible.value = false;
  await store.dispatch("groups/updateDepart", {
    id: row.id,
    name: cosNames.value,
  });
  await store.dispatch("groups/getDepartList", {teamId: teamId.value});
};

// 添加部门
const addDepartment = async () => {
  dialogVisibleAddDepartment.value = true;
  let targetObj = {
    createBy: "",
    createTime: `${dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss")}`,
    delFlag: 0,
    id: "",
    name: departmentNameAdd.value,
    remark: "",
    sort: 0,
    teamId: teamId.value,
    updateBy: "",
    updateTime: "",
  };
  await store.dispatch("groups/addDepart", targetObj);
  await store.dispatch("groups/getDepartList", {teamId: teamId.value});
  dialogVisibleAddDepartment.value = false;
  departmentNameAdd.value = "";
};

// 删除
const handleDelete = async (row, column, $index) => {
  row.dialogVisible = true;
  await store.dispatch("groups/deleteDepart", {id: row.id});
  await store.dispatch("groups/getDepartList", {teamId: teamId.value});
};

// table 中的 confirm
const requestHandleDelete = (row) => {
  row.popoverVisible = true;
};
const cancelPopover = (row) => {
  row.popoverVisible = false;
};

const tableRowClassName = ({row, rowIndex}) => {
  return "change_grey";
};

onMounted(async () => {
  await store.dispatch("groups/getDepartList", {teamId: teamId.value});
});
watch(() => teamId.value, async () => {
  await store.dispatch("groups/getDepartList", {teamId: teamId.value});
})


const headerClassName = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 1 || columnIndex === 2) {
    return {'text-align': 'center',}
  } else {
    return {'text-align': 'left'}
  }
}

const rowClassName = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 1 || columnIndex === 2) {
    return {textAlign: 'center', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  } else {
    return {textAlign: 'left', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  }
}


// el-popover 优化
const refMap = ref({})
const tempRef = ref()
const visiblePopover = ref(false)
// -1-字句审核 0-整句审核 1-日志查看
const popoverType = ref(0)
const activeItemElpopover = ref(null)

const handleRef = debouncePlus((ref, item, type) => {
  console.log('refMap', refMap.value)
  tempRef.value = ref
  popoverType.value = type
  activeItemElpopover.value = item;
  if (type === 1) {
    // ...业务逻辑1
  } else {
    // ...业务逻辑2、3
  }
  visiblePopover.value = true
}, POPOVER_DELAY_TIME)

// 设置 临界值 width
const middleValueWidth = ref(160)
// 字数大致限制
const sizeMaxNumber = ref(13)


const clearVisiblePopover = () => {
  setTimeout(() => {
    visiblePopover.value = false
  }, POPOVER_DELAY_TIME + 10)
}


const handleClickSelectWidth = () => {

  if (flexWidth('name', tableData, i18n.global.t('common.department.name')) > middleValueWidth.value) {
    return middleValueWidth.value
  } else {
    if (flexWidth('name', tableData, i18n.global.t('common.department.name')) < 80) {
      return 80
    } else {
      return flexWidth('name', tableData, i18n.global.t('common.department.name'))
    }
  }
}

</script>

<style lang="less" scoped>
@import "./less/Right.less";
@import "../../less/page.less";

.settings_btn {
  display: flex;
  justify-content: center;
  margin-top: 15px;
  margin-bottom: 15px;
}

#sendRequire {
  margin-top: 25px;
  display: flex;
  justify-content: center;
}

:deep(.el-table__header) {
  width: 100% !important;
}

:deep(.el-table__body) {
  width: 100% !important;
}

:deep(.el-table .cell) {
  font-size: 13px !important;
  font-weight: normal !important;
}
</style>
